import { Link } from 'react-router-dom';
import { animeList } from '@/mocks/animeData';

export default function LatestUpdates() {
  const latestList = [...animeList].sort((a, b) => b.year - a.year).slice(0, 6);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            最新更新
          </h2>
          <p className="text-sm text-foreground-500 mt-1">第一时间获取最新动漫资源</p>
        </div>
        <Link
          to="/category/guoman"
          className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          查看更多 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {latestList.map((anime) => (
          <Link
            key={anime.id}
            to={`/article/${anime.id}`}
            className="group flex gap-4 bg-background-50 rounded-lg p-4 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
          >
            <div className="w-20 h-28 md:w-24 md:h-32 flex-shrink-0 rounded-md overflow-hidden">
              <img
                src={anime.cover}
                alt={anime.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="flex-1 min-w-0 flex flex-col justify-between">
              <div>
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {anime.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-2 leading-relaxed">
                  {anime.description}
                </p>
              </div>
              <div className="flex items-center gap-2 mt-2 flex-wrap">
                <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs whitespace-nowrap">
                  {anime.region}
                </span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{anime.episodes}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}